import React, { createContext, useContext, useState } from 'react';

const YearContext = createContext();

// Derive current academic year: if month >= 6 (June) it's current-next, else prev-current
function defaultYear() {
  const now   = new Date();
  const year  = now.getFullYear();
  const month = now.getMonth() + 1; // 1-based
  const start = month >= 6 ? year : year - 1;
  return `${start}-${String(start + 1).slice(-2)}`;
}

export function YearProvider({ children }) {
  const [year, setYear] = useState(() => {
    return localStorage.getItem('gs_academic_year') || defaultYear();
  });

  const changeYear = (y) => {
    localStorage.setItem('gs_academic_year', y);
    setYear(y);
  };

  return (
    <YearContext.Provider value={{ year, changeYear }}>
      {children}
    </YearContext.Provider>
  );
}

export function useYear() {
  return useContext(YearContext);
}
